import { lazy, Suspense } from 'react';

const SpreadJSViewer = lazy(() =>
  import('@/components/SpreadJSViewer').then(mod => ({
    default: mod.SpreadJSViewer,
  }))
);

interface OutputTabProps {
  rawOutput?: string;
  isValidJson: boolean;
  sheetJson?: any;
  computeValues?: any;
  error?: string;
}

export function OutputTab({
  rawOutput,
  isValidJson,
  sheetJson,
  computeValues,
  error,
}: OutputTabProps) {
  return (
    <div>
      {/* Raw Output */}
      <div style={{ marginBottom: '2rem' }}>
        <h3
          style={{
            fontSize: '1rem',
            fontWeight: 600,
            color: '#47331F',
            marginBottom: '0.75rem',
          }}
        >
          Raw Output
        </h3>
        <details>
          <summary
            style={{
              cursor: 'pointer',
              color: '#B7343A',
              fontSize: '0.875rem',
              marginBottom: '0.5rem',
            }}
          >
            Show raw text ({rawOutput?.length || 0} characters)
          </summary>
          <pre
            style={{
              padding: '1rem',
              background: '#1e1e1e',
              color: '#d4d4d4',
              borderRadius: '6px',
              fontSize: '0.8125rem',
              lineHeight: 1.6,
              overflow: 'auto',
              maxHeight: '300px',
            }}
          >
            {rawOutput || 'No output'}
          </pre>
        </details>
      </div>

      {/* Parsed JSON */}
      {isValidJson && sheetJson && (
        <div style={{ marginBottom: '2rem' }}>
          <h3
            style={{
              fontSize: '1rem',
              fontWeight: 600,
              color: '#47331F',
              marginBottom: '0.75rem',
            }}
          >
            Parsed JSON
          </h3>
          <details>
            <summary
              style={{
                cursor: 'pointer',
                color: '#B7343A',
                fontSize: '0.875rem',
                marginBottom: '0.5rem',
              }}
            >
              Show JSON structure
            </summary>
            <pre
              style={{
                padding: '1rem',
                background: '#1e1e1e',
                color: '#d4d4d4',
                borderRadius: '6px',
                fontSize: '0.8125rem',
                lineHeight: 1.6,
                overflow: 'auto',
                maxHeight: '400px',
              }}
            >
              {JSON.stringify(sheetJson, null, 2)}
            </pre>
          </details>
        </div>
      )}

      {/* Spreadsheet View */}
      {isValidJson && sheetJson && (
        <div>
          <h3
            style={{
              fontSize: '1rem',
              fontWeight: 600,
              color: '#47331F',
              marginBottom: '0.75rem',
            }}
          >
            Spreadsheet View
          </h3>
          <div
            style={{
              border: '1px solid #E8E3DD',
              borderRadius: '8px',
              minHeight: '600px',
            }}
          >
            <Suspense
              fallback={
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '600px',
                    color: '#8B7764',
                    fontSize: '0.9375rem',
                  }}
                >
                  Loading spreadsheet viewer...
                </div>
              }
            >
              <SpreadJSViewer
                sheetJson={sheetJson}
                computedValues={computeValues}
                height={600}
              />
            </Suspense>
          </div>
        </div>
      )}

      {/* Error Display */}
      {error && (
        <div
          style={{
            padding: '1rem',
            background: 'rgba(239, 68, 68, 0.1)',
            border: '1px solid rgba(239, 68, 68, 0.3)',
            borderRadius: '8px',
            color: '#991b1b',
          }}
        >
          <strong>Error:</strong> {error}
        </div>
      )}
    </div>
  );
}
